var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.656,
    height: 11.688,
    viewBox: "0 0 49.656 11.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "front",
    d: "M7.859-4.648h-4.5V0H1.016V-11.375H8.422v1.9H3.359v2.938h4.5Zm6.133.484H12.125V0H9.781V-11.375h4.227a4.778,4.778,0,0,1,3.109.9,3.1,3.1,0,0,1,1.094,2.539A3.5,3.5,0,0,1,17.707-6,3.437,3.437,0,0,1,16.18-4.758L18.641-.109V0H16.125Zm-1.867-1.9h1.891a1.936,1.936,0,0,0,1.367-.449,1.606,1.606,0,0,0,.484-1.238,1.719,1.719,0,0,0-.457-1.266,1.9,1.9,0,0,0-1.4-.461H12.125Zm17.211.633a6.867,6.867,0,0,1-.594,2.945,4.472,4.472,0,0,1-1.7,1.953,4.7,4.7,0,0,1-2.535.688,4.732,4.732,0,0,1-2.523-.68,4.515,4.515,0,0,1-1.719-1.941,6.67,6.67,0,0,1-.617-2.9V-5.93a6.831,6.831,0,0,1,.605-2.957,4.508,4.508,0,0,1,1.711-1.961,4.706,4.706,0,0,1,2.527-.684,4.706,4.706,0,0,1,2.527.684A4.508,4.508,0,0,1,28.73-8.887a6.811,6.811,0,0,1,.605,2.949Zm-2.375-.516a4.787,4.787,0,0,0-.641-2.719,2.088,2.088,0,0,0-1.828-.93,2.088,2.088,0,0,0-1.82.918,4.732,4.732,0,0,0-.648,2.691v.555a4.847,4.847,0,0,0,.641,2.7,2.082,2.082,0,0,0,1.844.961,2.064,2.064,0,0,0,1.813-.926,4.819,4.819,0,0,0,.641-2.7ZM40.289,0H37.945L33.383-7.484V0H31.039V-11.375h2.344l4.57,7.5v-7.5h2.336ZM50.672-9.477H47.188V0H44.844V-9.477H41.406v-1.9h9.266Z",
    transform: "translate(-1.016 11.531)",
    fill: "#111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFront);
export default __webpack_public_path__ + "static/media/front.b034e46e2f972bf75115c114fb41a7a3.svg";
export { ForwardRef as ReactComponent };